var TrandingSlider = new Swiper('.u-featured-products-box', {
    effect: "coverflow",
   centeredSlides: true,
   speed: 600,
   loopAdditionalSlides: 4,
   loopedSlides: 4,
   loop: true,
   slidesPerView: "auto",
    coverflowEffect: {
       rotate: 0,
       stretch: 0,
       depth: 200,
       modifier: 1,
       slideShadows: true,
    },
    navigation: {
       nextEl: ".swiper-button-next",
       prevEl: ".swiper-button-prev",
    },
    initialSlide: 1,
    breakpoints: {
      320: {
         slidesPerView: 1.5
      },
      768: {
         slidesPerView: 2
      },
      1024: {
         slidesPerView: 4
      }
   }
 });